/** Fixed UTC offsets never inherit DST or the operator's browser zone. */
export function offsetMinutes(zone: string): number | undefined {
  const match = /^UTC([+-])(\d{2}):(\d{2})$/.exec(zone);
  if (!match) { if (/^UTC[+-]/.test(zone)) throw new Error("Invalid UTC offset"); return undefined; }
  const minutes = Number(match[2]) * 60 + Number(match[3]);
  if (Number(match[3]) > 59 || minutes > (match[1] === "-" ? 720 : 840)) throw new Error("Invalid UTC offset");
  return minutes * (match[1] === "-" ? -1 : 1);
}
export const utcOffsets = Array.from({ length: 105 }, (_, index) => {
  const minutes = -720 + index * 15, absolute = Math.abs(minutes);
  return `UTC${minutes < 0 ? "-" : "+"}${String(Math.floor(absolute / 60)).padStart(2,"0")}:${String(absolute % 60).padStart(2,"0")}`;
});
export function companyDateLabel(iso: string, locale: string, zone: string): string {
  const offset = offsetMinutes(zone), date = new Date(iso);
  return offset === undefined ? date.toLocaleString(locale, { timeZone: zone })
    : new Date(date.getTime() + offset * 60000).toLocaleString(locale, { timeZone: "UTC" });
}
export function scheduleInput(iso: string, zone: string): string {
  const date = new Date(iso), offset = offsetMinutes(zone);
  return new Date(date.getTime() + (offset ?? -date.getTimezoneOffset()) * 60000).toISOString().slice(0,16);
}
export function scheduleUtc(value: string, zone: string): string {
  const offset = offsetMinutes(zone);
  const date = offset === undefined ? new Date(value) : new Date(new Date(`${value}Z`).getTime() - offset * 60000);
  if (!Number.isFinite(date.getTime())) throw new Error("Choose a valid date and time");
  return date.toISOString();
}
